function runWhenCartReady(itemsList) {
  const cartItems = itemsList.querySelectorAll(".item");

  cartItems.forEach((product) => {
    const itemProductURL = product.querySelector(".item-image-anchor").href;

    getProductTags(getHandle(itemProductURL)).then((tags) => {
      if (tags.length && !tags.includes("packs")) {
        updateMinusButton(product);
      }
    });
  });

  function updateMinusButton(item) {
    const quantitySelector = item.querySelector(".quantity-selector");
    const input = quantitySelector.querySelector("input");
    const minusBtn = quantitySelector.querySelector(
      '[aria-label="decrease quantity"]'
    );

    const observer = new MutationObserver(changeButtonStatus);

    observer.observe(input, {
      attributes: true,
      attributeFilter: ["value"],
    });

    changeButtonStatus();

    function changeButtonStatus() {
      const value = +input.value;

      if (value <= +window.minimumQuantity.value) {
        minusBtn.disabled = true;
      } else {
        minusBtn.disabled = false;
      }
    }
  }

  function getHandle(url) {
    const parts = url.split("/products/")[1];
    if (!parts) return null;
    return parts.split("?")[0];
  }

  async function getProductTags(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) throw new Error(`Product not found: ${handle}`);

      const product = await response.json();
      return product.tags || [];
    } catch (error) {
      console.error("Error:", error);
      return [];
    }
  }
}

const observer = new MutationObserver((mutations, obs) => {
  const cartItemsList = document.querySelector("#slidecarthq .items");
  if (cartItemsList) {
    runWhenCartReady(cartItemsList);
    // obs.disconnect();
  }
});

document.addEventListener("DOMContentLoaded", () => {
  observer.observe(document.body, { childList: true, subtree: true });
});
